import { resolveSavedIconClass } from 'dashboard/helper/legacyIconClass';

// Paleta fixa de ícones para campos personalizados.
// SiteUP V2 (F1.2e): catálogo em Phosphor (`i-ph-*`). As classes precisam aparecer
// LITERALMENTE aqui para o Tailwind/JIT (@egoist/tailwindcss-icons) gerar o CSS
// Classes montadas em runtime (ex.: `i-ph-${nome}`) não seriam geradas. Por
// isso guardamos/salvamos a classe completa.
//
// O que já está salvo em Remix ou Lucide continua compatível: a edição traduz
// a classe legada somente para marcar a opção equivalente.
export const CUSTOM_ATTRIBUTE_ICON_OPTIONS = [
  'i-ph-star',
  'i-ph-heart',
  'i-ph-flag',
  'i-ph-tag',
  'i-ph-bookmark',
  'i-ph-bell',
  'i-ph-calendar',
  'i-ph-clock',
  'i-ph-envelope',
  'i-ph-phone',
  'i-ph-map-pin',
  'i-ph-globe',
  'i-ph-user',
  'i-ph-users',
  'i-ph-buildings',
  'i-ph-briefcase',
  'i-ph-money',
  'i-ph-credit-card',
  'i-ph-shopping-cart',
  'i-ph-package',
  'i-ph-link',
  'i-ph-hash',
  'i-ph-info',
  'i-ph-check-circle',
  'i-ph-warning',
  'i-ph-hand-heart',
  'i-ph-thumbs-up',
  'i-ph-lightning',
];

export const REMIX_TO_PHOSPHOR = {
  'i-ri-star-line': 'i-ph-star',
  'i-ri-heart-line': 'i-ph-heart',
  'i-ri-flag-line': 'i-ph-flag',
  'i-ri-price-tag-line': 'i-ph-tag',
  'i-ri-bookmark-line': 'i-ph-bookmark',
  'i-ri-bell-line': 'i-ph-bell',
  'i-ri-calendar-2-line': 'i-ph-calendar',
  'i-ri-time-line': 'i-ph-clock',
  'i-ri-mail-line': 'i-ph-envelope',
  'i-ri-phone-line': 'i-ph-phone',
  'i-ri-map-pin-line': 'i-ph-map-pin',
  'i-ri-globe-line': 'i-ph-globe',
  'i-ri-user-line': 'i-ph-user',
  'i-ri-group-line': 'i-ph-users',
  'i-ri-building-2-line': 'i-ph-buildings',
  'i-ri-briefcase-line': 'i-ph-briefcase',
  'i-ri-money-dollar-box-line': 'i-ph-money',
  'i-ri-bank-card-line': 'i-ph-credit-card',
  'i-ri-shopping-cart-line': 'i-ph-shopping-cart',
  'i-ri-box-1-line': 'i-ph-package',
  'i-ri-link': 'i-ph-link',
  'i-ri-hashtag': 'i-ph-hash',
  'i-ri-information-line': 'i-ph-info',
  'i-ri-checkbox-circle-line': 'i-ph-check-circle',
  'i-ri-alert-line': 'i-ph-warning',
  'i-ri-hand-heart-line': 'i-ph-hand-heart',
  'i-ri-thumb-up-line': 'i-ph-thumbs-up',
  'i-ri-flashlight-line': 'i-ph-lightning',
};

export const CUSTOM_ATTRIBUTE_ICON_LABELS = Object.fromEntries(
  CUSTOM_ATTRIBUTE_ICON_OPTIONS.map(icon => [
    icon,
    `ATTRIBUTES_MGMT.ADD.FORM.ICON.OPTIONS.${icon.replace('i-ph-', '').replaceAll('-', '_').toUpperCase()}`,
  ])
);

export const normalizeAttributeIcon = icon => {
  const resolvedIcon = resolveSavedIconClass(icon);
  return REMIX_TO_PHOSPHOR[resolvedIcon] || resolvedIcon;
};
